var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ehr-card",
    {
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("font-awesome-icon", {
                staticClass: "text-primary mr-2 right",
                attrs: { icon: ["fad", "tasks"] }
              }),
              _vm._v(" "),
              _c("b", [_vm._v("Opdrachten")])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _c(
          "div",
          {
            staticClass: "spinner-border text-primary",
            attrs: { role: "status" }
          },
          [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v("Data wordt geladen...")
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }